import { messages } from '@/shared/i18n';
import { useAuthStore } from '@/store';

const copy = messages.common.siteScope;

/** Shown to site-scoped members with no staff record: they see no site data until it exists. */
export function UnlinkedSiteScopeNotice() {
  const status = useAuthStore((s) => s.user?.siteScopeStatus);
  if (status !== 'unlinked') {
    return null;
  }
  return (
    <div
      role="status"
      className="mx-8 mt-6 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      <p className="font-semibold">{copy.unlinkedTitle}</p>
      <p className="mt-1">{copy.unlinkedBody}</p>
    </div>
  );
}
